import React, { FC } from "react";
import { Stack } from "@ldp-web/component-library/ui/atoms/stack";
import { Pagination } from "@ldp-web/component-library/ui/molecules/pagination";
import { useSimpleTranslation } from "@ldp/simple-i18n";
import { useUpdateFilterQueryParams } from "../../hooks";
import { useRedirectLink } from "../../utils";
import { useSDMRouterContext } from "@ldp/sdm-contexts";

/** Pagination prop types */
export interface IPaginationComponentProps {
  page: number;
  pageSize: number;
  totalResults: number;
  showGapForPagination: boolean;
}

/** Component to render Pagination */
export const PaginationComponent: FC<IPaginationComponentProps> = ({
  totalResults,
  pageSize,
  page,
  showGapForPagination,
}) => {
  const i18n = useSimpleTranslation();
  const pageCount = Math.ceil(totalResults / pageSize);
  const showPagination = pageCount > 1;
  const router = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);
  const updateFilterQueryParams = useUpdateFilterQueryParams();

  /**
   * Function to handle pagination
   * @param page selected page number
   * updates query parameter and selected page number, makes api call
   */
  const handlePagination = (page: number) => {
    if (page < 1 || page > pageCount) return;

    const queryParam = {
      page: page.toString(),
    };
    const updatedUrl = updateFilterQueryParams(queryParam, true);
    redirectToPage(updatedUrl);
  };

  return (
    <>
      {showPagination && (
        <Stack mx="auto" alignItems="center" mb={10} py={14}>
          <Pagination
            count={pageCount}
            page={page}
            siblingCount={1}
            boundaryCount={2}
            onChange={handlePagination}
            paginationNavAriaLabel={i18n("a11yPagination")}
            ariaLabelPrev={i18n("a11yPreviousPage")}
            ariaLabelNext={i18n("a11yNextPage")}
            pagei18n={i18n("a11yPageNumber")}
            hasGapBetweenPaginationItemsOnSmallerViews={showGapForPagination}
          />
        </Stack>
      )}
    </>
  );
};

export default PaginationComponent;
